module.exports = __webpack_public_path__ + "static/media/noImageXLV.73ec76e5.jpg";